import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'menuKeyChecker',
  standalone: true,
})
export class MenuKeyCheckerPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    switch (value) {
      case 'SHORTSTAY':
        return 'menu-shortstay';
      case 'EXTENDEDSTAY':
        return 'menu-extendedstay';
      case 'SERVICE_APARTMENT':
        return 'menu-service-apartment';
      case 'HOME_STAYS':
        return 'menu-home-stays';
      case 'RESORTS':
        return 'menu-resorts';
      case 'EXPERIENCES':
        return 'menu-experiences';
      case 'FOLLOW_MY_STORY': //'FOLLOW_MY_STORY':
        return 'menu-story';
      default:
        console.warn('menu key is missing ==> ', value);
    }
    return value;
  }
}
